import { render, staticRenderFns } from "./AppUsos.vue?vue&type=template&id=50a32a27&"
import script from "./AppUsos.vue?vue&type=script&lang=js&"
export * from "./AppUsos.vue?vue&type=script&lang=js&"
import style0 from "./AppUsos.vue?vue&type=style&index=0&id=50a32a27&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports